<template>
  <el-row class="feed-header">
    <el-col class="feed-header__info">
      {{userName}}
      <!--<el-button type="text" class="feed-header__button">Настройки</el-button>-->
    </el-col>
  </el-row>
</template>

<script>
/*feed-header component*/

export default {
  name: "FeedHeader",
  props: {
    userName: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
  .feed-header {
    margin-bottom: 10px;
  }

  .feed-header__info {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
  }

  .feed-header__button {
    font-family: inherit;
    font-size: 12px;
    color: #d7d9de;
  }
</style>
